// extracted by mini-css-extract-plugin
export default {"theme-light":"ar8Grz"};